module.exports = __webpack_public_path__ + "img/033.85b1ebd2.png";